import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { Attestation, BrowserAttestation, CompromiseReports } from "../service/global.service";

/**
 * Pipe certifying a search compromise reports | Optional
 */
@Pipe({
  name: 'existingReports',
  standalone: true
})
export class ExistObjectPipe implements PipeTransform {
  transform(items: Attestation[] | CompromiseReports[] | BrowserAttestation[] | undefined): any[] {
    if (!items) {
      return [];
    } else return items;
  }
}


/**
 * Pipe parsing an any string url as a safe url
 */
@Pipe({
  name: 'safe',
  standalone: true
})

export class SafePipe implements PipeTransform {

  constructor(private readonly sanitizer: DomSanitizer) { }
  transform(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}